<template>
    <Player
        :podcast="podcast"
        :colors="colors"
        :startAt="startAt"
        :shareUrl="shareUrl"
        :subscribeUrl="subscribeUrl"
        :logUrl="logUrl"
        :hidePlaylist="hidePlaylist"
        :preview="preview"
    />
</template>

<script setup>
import Player from '../Player/Player.vue';

const props = defineProps({
    podcast: Object,
    colors: Object,
    startAt: Number,
    shareUrl: String,
    subscribeUrl: String,
    logUrl: String,
    hidePlaylist: Boolean,
    preview: Boolean,
});

// Get the root element
const r = document.querySelector(':root');

r.style.setProperty('--player-accent', props.colors.player_main_accent);
r.style.setProperty('--player-contrast', props.colors.player_main_contrast);
r.style.setProperty('--player-background', props.colors.player_background);
r.style.setProperty('--player-list-item', props.colors.player_list_item);

</script>

<style>
body {
    font-family: 'Comfortaa', sans-serif
}
</style>
